<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶部导航栏 -->
      <div class="topbar">
        <div class="nav-left">
          <div class="nav-title">
            <img src="../public/img/title-logo.png" style="height: 50px;"/>
          </div>
          <a class="nav-home" href="#/" style="padding-left: 45px;padding-right: 45px">
            <span style="text-decoration: black"> &nbsp;</span>首页<span style="text-decoration: black">&nbsp;</span>
          </a>
          <a class="nav-home" href="#/purchase" style="padding-right: 45px">
            <span style="text-decoration: black"> &nbsp;</span>订购<span style="text-decoration: black">&nbsp;</span>
          </a>
          <!--          <a class="nav-home" target="_blank" href="https://www.zhsh10000.com/profile/upload/2024/02/18/%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf">
                      <span style="text-decoration: black"> &nbsp;</span>帮助<span style="text-decoration: black">&nbsp;</span>
                    </a>-->

          <a class="nav-home" target="_blank" :href="$targetUrl + '#/assist/'" rel="nofollow">
            <span style="text-decoration: black"> &nbsp;</span>帮助<span style="text-decoration: black">&nbsp;</span>
          </a>
        </div>
        <!--        用户头像处理-->
        <div class="nav-right">
          <!--          没有登陆时显示登录注册按钮-->
          <div v-if="!this.$store.getters.getUser " @click="login" id="login-id">
            <div class="nav-login">
              <el-button type="text">登录</el-button>
              <span class="sep">/</span>
              <el-button type="text">注册</el-button>
            </div>
          </div>
          <!--					登陆时显示用户基本信息-->
          <div style="display: flex;align-items: center;" v-else>
            <img
                :src="this.$store.getters.getUser.avatar? this.$store.getters.getUser.avatar:handeImg"
                style="width: 2.225rem;height: 2.225rem;border-radius: 50%;margin-right: 0.625rem;"/>
            <el-popover placement="bottom-start" trigger="hover" width="180" v-model="visible">
              <div style="display: flex;align-items: center;">
                <img :src="this.$store.getters.getUser.avatar?this.$store.getters.getUser.avatar:handeImg "
                     style="width: 2.925rem;height: 2.925rem;border-radius: 50%;margin-right: 0.625rem;"/>
                <div>
                  <div>{{ this.$store.getters.getUser.nickname }}</div>
                  <div>ID:{{ this.$store.getters.getUser.userNo }}</div>
                </div>
              </div>

              <div
                  style="margin-top: 0.625rem;border-top: 0.0625rem solid #F0F0F0;line-height: 1.875rem;padding-top: 0.625rem;cursor: pointer;">
                <div style="display: flex;align-items: center;" @click="myProfileHandle"><img
                    src="../public/img/user.png" style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>个人中心
                </div>
                <div style="display: flex;align-items: center;" @click="myProfileHandle">
                  <img
                    src="../public/img/password.png" style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>修改密码
                </div>
                <div style="display: flex;align-items: center;" @click="logout">
                  <img src="../public/img/layout.png" style="width: 0.925rem;height: 0.925rem;margin-right: 0.925rem;"/>退出登录
                </div>
              </div>
              <button slot="reference" style="background: #FFFFFF;">{{ this.$store.getters.getUser.nickname }}</button>
            </el-popover>
          </div>
        </div>
      </div>
      <!-- 顶部导航栏END -->

      <!-- 登录模块 -->
      <MyLogin @getUserNo="getUserNo"></MyLogin>

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive :include="['Purchase','HomePage']">
          <router-view></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <input style="display: none;" id="userNo"/>

      <!-- 底栏容器 -->
      <el-footer>
        <div class="bottom">
          <div class="bottom-content pr">
            <div class="bottom-one-box oh">
              <div class="bottom-area aboutus">
                <div class="bottom-area-title">关于我们</div>
                <div class="bottom-area-list">
                  <a target="_blank" :href="$targetUrl + '#/about/'" rel="nofollow">关于我们</a>
                </div>
              </div>
              <div class="bottom-area shengming">
                <div class="bottom-area-title">政策声明</div>
                <div class="bottom-area-list">
                  <a target="_blank" :href="$targetUrl + '#/shengming/'" rel="nofollow">版权声明</a>
                  <a target="_blank" :href="$targetUrl + '#/agreement/'" rel="nofollow">注册协议</a>
                  <a target="_blank" :href="$targetUrl + '#/privacy/'" rel="nofollow">隐私政策</a>
                </div>
              </div>
              <div class="bottom-area followme">
                <div class="bottom-area-title">关注我们</div>
                <div class="bottom-area-ewm"></div>
              </div>
              <div class="bottom-area kefuonline">
                <div class="bottom-area-title">联系我们</div>
                <div class="btm-contact-us-x">
                  <div>客服QQ：{{ this.$store.getters.getQQService }}</div>
                  <div>客服邮箱：{{this.$store.getters.getQQService}}@qq.com</div>
                  <div>投诉反馈：{{ this.$store.getters.getQQService }}@qq.com</div>
                  <div>商务合作：{{this.$store.getters.getQQService}}@qq.com</div>
                  <!--									<div>客服邮箱：sashion@foxmail.com</div>
                                    <div>投诉反馈：sashion@foxmail.com</div>
                                    <div>商务合作：sashion@foxmail.com</div>-->
                </div>
              </div>
            </div>
            <div class="copyright-box center pr">
              <div class="copyright-text-f pa"> <span>Copyright © 2023-2023 智慧生活10000号 &nbsp;·&nbsp; <a
                  href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
                  rel="nofollow">闽ICP备2023019519号-1</a></span>
              </div>
            </div>
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import {
  mapActions
} from "vuex";
import {
  mapGetters
} from "vuex";
import {
  getCurrentUserInfo,
  layout
} from "./api/loginApi"
import {
  getToken,
  removeToken
} from "@/utils/auth"
import { getConfigQQ } from '@/api/config'
export default {
  data() {
    return {
      register: false, // 是否显示注册组件
      visible: false,// 是否退出登录
      userNo: '',
      url: this.$targetUrl + "/profile/upload/2024/02/18/使用手册.pdf",
      handeImg: require('./assets/imgs/head-sculpture.png'),
    };
  },

  created() {

    this.getQQKefu()

    // 获取浏览器localStorage，判断用户是否已经登录
    if (localStorage.getItem("user") && getToken() !== undefined) {
      // 如果已经登录，设置vuex登录状态
      getCurrentUserInfo().then((res) => {
        this.setUser(res.data);
      })
    } else {
      localStorage.removeItem("user")
    }
  },
  computed: {
    ...mapGetters(["getUser","getQQService"]),
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin","setQQService"]),
    // 获取qq联系方式

    getQQKefu(){
        getConfigQQ("qq").then(res => {
          this.setQQService(res.data.content);
        })
    },

    getUserNo(e) {
      this.userNo = e
      document.getElementById("userNo").value = e
    },

    myProfileHandle() {
      this.visible = false
      this.$router.push({
        path: "/profile"
      });
    },
    login() {
      // 点击登录按钮, 通过更改vuex的showLogin值显示登录组件
      this.setShowLogin(true);
    },
    // 退出登录
    logout() {
      this.visible = false;
      layout().then(() => {
        // 清空本地登录信息
        localStorage.setItem("user", "");
        // 清空vuex登录信息
        this.setUser("");
        removeToken("")
        this.notifySucceed("成功退出登录");
      })
    },
    // 接收注册子组件传过来的数据
    isRegister(val) {
      this.register = val;
    },
  }
};
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;

}

#app {
  min-width: 78.125rem;
}

#app .el-header {
  padding: 0;
}

#app .el-main {
  min-height: 18.75rem;
  padding: 0;
}

#app .el-footer {
  padding: 0;
}

a,
a:hover {
  text-decoration: none;
}

/* 全局CSS END */

/* 顶部导航栏CSS */
.topbar {
  height: 70px;
  background-color: #FFFFFF;
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: center;
  padding: 0 85px;
  border-bottom: 1px solid #DEDEDE;
}

.topbar .nav-left {
  display: flex;
  justify-items: center;
  align-items: center;
}

.topbar .nav-left .nav-title {
  font-weight: bold;
  color: #FCA82D;
//margin-right: 100px;
}

.topbar .nav-left .nav-home {
  color: #000000;
  margin-bottom: 10px;
}

.topbar .nav-left a:hover {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.5rem;
}

.topbar .nav-right .nav-login {
  background: #0C75EA;
//margin: 0.625rem; padding: 0 0.85rem; border-radius: 0.3125rem;
}

.topbar .nav-right .sep {
  color: #FFFFFF;
  font-size: 0.75rem;
  margin: 0 0.3125rem;
}

.topbar .nav-right .el-button {
  color: #FFFFFF;
}

.topbar .nav-right .el-button:hover {
  color: #fff;
}

.topbar .nav-right a {
  color: #b0b0b0;
}

.topbar .nav-right a:hover {
  color: #fff;
}

/* 顶部导航栏CSS END */

/* 顶栏容器CSS */
.el-header .el-menu {
  max-width: 76.5625rem;
  margin: 0 auto;
}

.el-header .logo {
  height: 3.75rem;
  width: 11.8125rem;
  float: left;
  margin-right: 6.25rem;
}

.el-header .so {
  margin-top: 0.625rem;
  width: 18.75rem;
  float: right;
}

/* 顶栏容器CSS END */

.bottom {
  width: 100%;
  background: #FFFFFF;
  min-height: 400px;
  overflow: hidden;
//min-width: 1200px;
}

.bottom .bottom-content {
  margin-left: 85px;
  margin-right: 85px;
  margin-top: 80px;
  background-color: #272A33;
  max-width: 100%;
//min-width: 1200px; width: auto; height: 100%;
  color: #818992;
  padding: 0px 140px;
//margin: 0 auto;
}

.pr {
  position: relative;
}

.bottom .bottom-content .bottom-one-box {
  min-height: 250px;
  padding-bottom: 40px;
  position: relative;
}

.oh {
  overflow: hidden;
}

.bottom .bottom-content .aboutus {
  width: 25%;
}

.bottom .bottom-content .bottom-area-title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin: 80px 0 30px 0;
}

.bottom .bottom-content a {
  color: #818992;
}

a {
  text-decoration: none;
  outline: none;
}

.bottom .bottom-content .aboutus a,
.bottom .bottom-content .shengming a {
  display: block;
  margin-bottom: 20px;
}

.bottom .bottom-content .bottom-area {
  float: left;
  font-size: 14px;
  display: inline-block;
}

.bottom .bottom-content .shengming {
  width: 25%;
}

.bottom .bottom-content .followme {
  width: 25%;
}

.bottom .bottom-content .kefuonline {
  width: 25%;
}

.bottom .bottom-content .webtag {
  width: 540px;
  float: right;
}

.bottom .bottom-content .copyright-box {
  font-size: 0;
  width: 100%;
  height: 100px;
  left: 0px;
  bottom: 0px;
  border-top: 1px solid #2E313A;
}

.center {
  text-align: center;
}

.bottom .bottom-content .copyright-box {
  font-size: 0;
  width: 100%;
  height: 100px;
  left: 0px;
  bottom: 0px;
  border-top: 1px solid #2E313A;
}

.bottom .bottom-content .copyright-box .copyright-text-f {
  top: 20px;
}

.bottom .bottom-content .copyright-box div {
  left: 0;
  width: 100%;
  text-align: center;
}

.pa {
  position: absolute;
}

.bottom .bottom-content .copyright-box div span {
  font-size: 12px;
  color: #818992;
  line-height: 20px;
}

.bottom .bottom-content .copyright-box .beianico {
  display: inline-block;
  position: relative;
  top: 4px;
  width: 20px;
  height: 20px;
  background: url(assets/imgs/beian.png);
}

.bottom .bottom-content .bottom-area-ewm {
  width: 80px;
  height: 80px;
  background: url(assets/imgs/qrcode.jpg) center;
  background-size: 80px 80px;
}

/* 底栏容器CSS END */
</style>
